import { connect } from 'react-redux'
import { downloadCSVData } from '../../actions/utilities'
import DownloadCSVComponent from '../../components/UtilitiesComponents/DownloadCSVComponent'

const mapDispatchToProps = { downloadCSVData }

export default connect(null, mapDispatchToProps)(DownloadCSVComponent)
